import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Route, Switch, withRouter } from "react-router-dom";
import { PropTypes } from "prop-types";

import ErrorBoundary from "../../components/errorBoundaries/ErrorBoundary.jsx";
import SentryHeader from "../../components/sentry/SentryHeader.jsx";
import PasswordReset from "./PasswordReset.jsx";
import PasswordRequest from "./PasswordRequest.jsx";
import UsernameRecovery from "./UsernameRecovery.jsx";
import VerificationRecovery from "./VerificationRecovery.jsx";
import Register from "./Register.jsx";
import RegisterMarketplace from "./RegisterMarketplace.jsx";
import LoginMarketplace from "./LoginMarketplace.jsx";
import LoginFederatedLink from "./LoginFederatedLink.jsx";
import LoginFederatedCallback from "./LoginFederatedCallback.jsx";
import Login from "./Login.jsx";
import ScheduledMessage from "../../components/notifications/ScheduledMessage.jsx";

import { ROUTES } from "../../constants/routing.js";

import { updateHelpWidget } from "../../state/reducers/helpWidget/helpWidgetActions.js";

import { selectTestingEnvironment } from "../../state/reducers/config/configSelectors.js";
import { selectSystemNotification } from "../../state/reducers/notifications/notificationSelectors.js";
import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class Sentry extends PureComponent {
  static propTypes = {
    testingEnvironment: PropTypes.string,
    systemNotification: PropTypes.object,
    copy: PropTypes.func.isRequired
  };

  componentDidMount() {
    const { updateHelpWidget, copy } = this.props;

    const data = {
      subject: copy("help_widget.sentry.subject"),
      description: copy("help_widget.sentry.description")
    };

    updateHelpWidget(data);
  }

  // -- RENDER -- //

  render() {
    const { testingEnvironment, systemNotification } = this.props;

    const className = testingEnvironment
      ? `sentry testing_environment`
      : `sentry`;

    return (
      <div className={className}>
        <SentryHeader testingEnvironment={testingEnvironment} />
        {systemNotification && (
          <div className="sentry-form">
            <ScheduledMessage
              title={systemNotification.title}
              message={systemNotification.message}
              startTime={systemNotification.startTime}
              endTime={systemNotification.endTime}
            />
          </div>
        )}
        <ErrorBoundary>
          <Switch>
            <Route path={ROUTES.SIGNUP} component={Register} />;
            <Route
              path={`${ROUTES.MARKETPLACE_REGISTER}/:provider/:token`}
              component={RegisterMarketplace}
            />
            <Route
              path={`${ROUTES.MARKETPLACE_LOGIN}/:provider/:token`}
              component={LoginMarketplace}
            />
            <Route
              path={ROUTES.FEDERATED_LOGIN_CALLBACK}
              component={LoginFederatedCallback}
            />
            <Route
              path={ROUTES.FEDERATED_LOGIN_LINK}
              component={LoginFederatedLink}
            />
            <Route
              path={`${ROUTES.PASSWORD_RESET}/:token`}
              component={PasswordReset}
            />
            <Route
              exact
              path={ROUTES.PASSWORD_RESET}
              component={PasswordRequest}
            />
            <Route
              exact
              path={ROUTES.USERNAME_RECOVERY}
              component={UsernameRecovery}
            />
            <Route
              exact
              path={ROUTES.VERIFICATION_RECOVERY}
              component={VerificationRecovery}
            />
            <Route path="/:section/:id/:action" component={Login} />
            <Route component={Login} />
          </Switch>
        </ErrorBoundary>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  testingEnvironment: selectTestingEnvironment(state),
  systemNotification: selectSystemNotification(state),
  copy: selectCopy(state)
});

const mapDispatchToProps = dispatch => ({
  updateHelpWidget: data => dispatch(updateHelpWidget(data))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Sentry));
